import {
  Document,
  Font,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer"

import React from "react"
import { getPartColor } from "utils/PartUtils"
import { pdf } from "@react-pdf/renderer"
import { saveAs } from "file-saver"
import { getCustomerSetPriceTotal } from "apollo/reactive-variables/configuratorVariables"

const LogoSchneider = require("images/logoSchneider.png")
const LogoVypinac = require("images/logoVypinac.png")

//
// PDF STYLES
//

/* HOW TO REGISTER A FONT:
 * - get Google Font url: https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;600;700;800;900&display=swap
   - in terminal: 'curl <url>'
   - copy the returned url of ttf font: https://fonts.gstatic.com/s/nunito/v13/XRXW3I6Li01BKofA-sekZg.ttf
 */
Font.register({
  family: "Nunito",
  src: "https://fonts.gstatic.com/s/nunito/v13/XRXV3I6Li01BKof4Mg.ttf",
})

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "white",
    padding: 30,

    fontFamily: "Nunito",
    fontSize: 14,
  },

  row: {
    flexDirection: "row",
    paddingLeft: 20,
    paddingTop: 6,
    paddingBottom: 6,
  },

  rowTitle: {
    width: 250,
  },
})

//
// PDF - COMPONENTS
//
const pdfHeader = () => {
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "flex-end",
        margin: 0,
        marginBottom: 15,
        padding: 0,
      }}
      fixed={true}
    >
      <Image
        src={LogoSchneider}
        style={{
          width: "50px",
          height: "15px", // 0.3 * width
        }}
      ></Image>
      <Image
        src={LogoVypinac}
        style={{
          width: "75px",
          height: "15px", // 0.21 * width
          marginLeft: "10px",
        }}
      ></Image>
    </View>
  )
}

const pdfProductLine = productSubLine => {
  return (
    <View
      style={{
        ...styles.row,
        border: 1,
        borderColor: "black",
        borderRadius: 4,
        marginTop: 10,
        marginBottom: 10,
      }}
    >
      <Text style={{ width: 200, marginTop: 5 }}>Produktová řada:</Text>
      <Text style={{ fontSize: 20 }}>{productSubLine?.ProductLine?.Name} </Text>
      <Text style={{ fontSize: 20 }}>{productSubLine?.Name}</Text>
    </View>
  )
}

const pdfPart = ({ name, color, id }) => {
  const value = ({ label, value, width }) => {
    return (
      <View
        style={{
          flexDirection: "column",
          width: width,
        }}
      >
        <Text style={{ color: "grey", fontSize: 10 }}>{label}:</Text>
        <Text>{value}</Text>
      </View>
    )
  }
  return (
    <View style={styles.row}>
      <View
        style={{
          flexDirection: "row",
        }}
      >
        {value({ label: " ", value: `${name}:`, width: 160 })}
        {value({ label: "Barva", value: color, width: 190 })}
        {value({ label: "Produktový kód", value: id, width: 300 })}
      </View>
    </View>
  )
}

const pdfContact = () => {
  const value = ({ label, value }) => {
    return (
      <View
        style={{
          flexDirection: "row",
        }}
      >
        <Text style={{ color: "grey", width: 50 }}>{label}:</Text>
        <Text>{value}</Text>
      </View>
    )
  }
  return (
    <View
      style={{
        flexDirection: "row",
        borderTop: 1,
        borderColor: "grey",
        fontSize: 11,
        marginTop: 20,
        paddingTop: 5,
      }}
    >
      <Text
        style={{
          ...styles.row,
          width: 324,
        }}
      >
        Zákaznické centrum:
      </Text>
      <View>
        {value({ label: "Telefon", value: "+420 225 382 919" })}
        {value({ label: "Email", value: "podpora@se.com" })}
      </View>
    </View>
  )
}

const pdfSpacer = () => {
  return <View style={{ flexGrow: 1 }}></View>
}

//
// PDF - VISUALIZER
//
export const downloadVisualizerPdf = async (
  customerSet,
  productSubLine,
  previewImage
) => {
  const FILENAME = "vypinac-vizualizace.pdf"

  const selectedFrame = customerSet?.visualizer?.selectedParts?.frame
  const selectedDecorativeFrame =
    customerSet?.visualizer?.selectedParts?.decorativeFrame
  const selectedDevice = customerSet?.visualizer?.selectedParts?.device

  const blob = await pdf(
    <Document>
      <Page size="A4" style={styles.page}>
        {pdfHeader()}

        <View
          style={{
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Image src={previewImage} />
        </View>

        {pdfProductLine(productSubLine)}

        {selectedDevice &&
          pdfPart({
            name: "Mechanismus",
            color: selectedDevice.Properties.find(p => p.Color).Color.Name,
            id: selectedDevice.PartNumber,
          })}

        {selectedFrame &&
          pdfPart({
            name: "Krycí rámeček",
            color: selectedFrame.Properties.find(p => p.Color).Color.Name,
            id: selectedFrame.PartNumber,
          })}

        {selectedDecorativeFrame &&
          pdfPart({
            name: "Dekorativní rámeček",
            color: selectedDecorativeFrame.Properties.find(p => p.Color).Color
              .Name,
            id: selectedDecorativeFrame.PartNumber,
          })}

        {pdfSpacer()}
        {pdfContact()}
      </Page>
    </Document>
  ).toBlob()

  saveAs(blob, FILENAME)
}

//
// PDF - CART - CUSTOMER SET
//
const pdfCartSectionRow = ({ name }) => {
  return (
    <View
      style={{
        ...styles.row,
        height: 50,
        paddingTop: 20,
        marginLeft: -15,
      }}
    >
      <Text style={{ width: 1000, textTransform: "uppercase", fontSize: 12 }}>
        {name}
      </Text>
    </View>
  )
}

const pdfCartValue = ({ label, value, width, marginRight = 0 }) => {
  return (
    <View
      style={{
        flexDirection: "column",
        width: width,
        marginRight: marginRight,
      }}
    >
      <Text style={{ color: "grey", fontSize: 8 }}>{label}:</Text>
      <Text style={{ color: "black", fontSize: 9, flexWrap: "wrap" }}>
        {value}
      </Text>
    </View>
  )
}

const pdfTotalRow = ({ priceTotal }) => {
  return (
    <View
      style={{
        ...styles.row,
        height: 50,
        paddingTop: 20,
        marginLeft: -15,
      }}
    >
      <Text
        style={{
          width: 350,
          height: 1,
          border: 1,
          borderColor: "black",
          borderRadius: 4,
          marginTop: 10,
          marginBottom: 10,
        }}
      ></Text>
      <Text
        style={{
          width: 30,
        }}
      ></Text>
      <Text style={{ width: 400, fontSize: 12 }}>
        {`Cena Sestavy:  ${priceTotal} kč`}
      </Text>
    </View>
  )
}

const pdfCartRow = ({ name, id, unitPrice, count, color }) => {
  return (
    <View
      style={{
        ...styles.row,
        height: 38,
        marginLeft: -15,
      }}
      key={`${name}-${id}`}
    >
      {pdfCartValue({
        label: "Ks",
        value: `${count}`,
        width: 45,
        marginRight: 0,
      })}
      {pdfCartValue({
        label: "Název",
        value: name,
        width: 275,
        marginRight: 5,
      })}
      {/* {pdfCartValue({ label: "Barva", value: color?.Name || "-", width: 110 })} */}
      {pdfCartValue({ label: "Produktový kód", value: id, width: 90 })}
      {pdfCartValue({
        label: "Cena/Ks",
        value: `${unitPrice} kč`,
        width: 60,
      })}
      {pdfCartValue({
        label: "Cena celkem",
        value: `${unitPrice * count} kč`,
        width: 100,
      })}
    </View>
  )
}

const cartSectionRows = ({ sectionName, cartArray }) => {
  const tempRows = []
  if (cartArray?.length) {
    tempRows.push(pdfCartSectionRow({ name: sectionName }))
    cartArray.forEach(item => {
      tempRows.push(
        pdfCartRow({
          name: item.product?.pdfName || item.product?.Name,
          id: item.product?.PartNumber,
          unitPrice: item.product?.Price,
          count: item.count,
          color: getPartColor(item.product),
        })
      )
    })
  }
  return tempRows
}

const cartRows = cart => {
  const rows = []
  if (cart.devices?.length) {
    rows.push(
      ...cartSectionRows({
        sectionName: "Přístroje",
        cartArray: cart.devices,
      })
    )
  }
  if (cart.frames?.length) {
    rows.push(
      ...cartSectionRows({
        sectionName: "Rámečky",
        cartArray: cart.frames,
      })
    )
  }
  if (cart.decorativeFrames?.length) {
    rows.push(
      ...cartSectionRows({
        sectionName: "Dekorativní rámečky",
        cartArray: cart.decorativeFrames,
      })
    )
  }
  if (cart.constructionFrames?.length) {
    rows.push(
      ...cartSectionRows({
        sectionName: "Montážní rámeček",
        cartArray: cart.constructionFrames,
      })
    )
  }
  return rows
}

export const downloadCustomerSetCartPdf = async (
  customerSets,
  productSubLines
) => {
  const FILENAME = `${customerSets.map(cs => cs.name).join("-")}.pdf`

  const blob = await pdf(
    <Document>
      {customerSets.map(customerSet => {
        const productSubLine = productSubLines?.find(
          productSubLine => productSubLine.id === customerSet.productLineId
        )
        return (
          <Page size="A4" style={styles.page}>
            {pdfHeader()}
            {pdfProductLine(productSubLine)}

            {cartRows(customerSet.cart)}
            {pdfTotalRow({ priceTotal: getCustomerSetPriceTotal(customerSet) })}

            {pdfSpacer()}
            {pdfContact()}
          </Page>
        )
      })}
    </Document>
  ).toBlob()

  saveAs(blob, FILENAME)
}
